import { cn } from 'utils/styles';
import { DELTA_COPY } from './constants';
import { formatCurrency } from './currency';
import type { BudgetResult } from './types';

interface BudgetCalculatorSummaryProps {
  result: BudgetResult;
}

/** Use the repo's font-size utility: tailwind-merge treats Chimekit's `text-label-sm` as a color. */
const PILL = 'rounded-full px-3 py-1 text-label-saans';

export const BudgetCalculatorSummary = ({ result }: BudgetCalculatorSummaryProps) => (
  <div className="flex flex-col gap-6">
    <dl className="flex flex-col gap-4 sm:flex-row sm:gap-8">
      <div className="flex items-center gap-2">
        <dt className={cn(PILL, 'bg-accent-green-200 text-accent-green-600')}>Income:</dt>
        <dd className="text-label-saans">{formatCurrency(result.income)}</dd>
      </div>

      <div className="flex items-center gap-2">
        <dt className={cn(PILL, 'bg-accent-yellow-200 text-accent-yellow-600')}>Allocated:</dt>
        <dd className="text-label-saans">{formatCurrency(result.allocated)}</dd>
      </div>
    </dl>

    {result.status === 'balanced' ? (
      <p className="text-body-saans">{DELTA_COPY.balanced}</p>
    ) : (
      <div className="flex flex-wrap items-center gap-2">
        <p className="text-body-saans">{DELTA_COPY[result.status]}</p>
        <p
          className={cn(
            PILL,
            result.status === 'over' ? 'bg-accent-pink-200 text-accent-pink-600' : 'bg-accent-grey-200',
          )}>
          {formatCurrency(result.delta)}
        </p>
      </div>
    )}
  </div>
);
